export function setDashConfig(cf) {
    localStorage.setItem('dashConfig', JSON.stringify(cf));
}

export function getDashConfig() {
    return JSON.parse(localStorage.getItem('dashConfig'));
}
